import { Link } from "react-router-dom";

import AVIcon from "../../../components/icons/AllVoicedIcons";
import {
  ApplicationSectionHeader,
  ApplicationSurface,
} from "../../../components/application";

const WORK_SURFACES = [
  {
    title: "Catalog",
    to: "/app/catalog",
    icon: "library",
    description:
      "Explore activities, resources, programs, services, and other offerings available through All-Voiced."
  },
  {
    title: "Participate",
    to: "/app/participate",
    icon: "inbox",
    description:
      "Join live sessions and access Projects that have been made available to you."
  },
  {
    title: "Facilitate",
    to: "/app/facilitate",
    icon: "send",
    description:
      "Start live sessions and run activities with others."
  }
];

export default function DashboardWorkSurfaceSection() {
  return (
    <section
      aria-labelledby="dashboard-work-surfaces-title"
      className="av-dashboard-work-surfaces"
    >
      <ApplicationSectionHeader
        title="What would you like to do?"
        titleId="dashboard-work-surfaces-title"
      />

      <nav
        aria-label="Primary All-Voiced work surfaces"
        className="av-dashboard-work-surfaces__grid"
      >
        {WORK_SURFACES.map((surface) => (
          <ApplicationSurface
            as={Link}
            className="av-dashboard-work-surfaces__card"
            key={surface.to}
            to={surface.to}
            variant="nested"
          >
            <span
              aria-hidden="true"
              className="av-app-icon-badge av-dashboard-work-surfaces__icon"
            >
              <AVIcon icon={surface.icon} size={18} />
            </span>
            <span className="av-dashboard-work-surfaces__copy">
              <strong>{surface.title}</strong>
              <span>{surface.description}</span>
            </span>
          </ApplicationSurface>
        ))}
      </nav>
    </section>
  );
}
